import React, { createContext, useContext, useState } from "react";
const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [baseUrl, setBaseUrl] = useState("https://esthetica.btsportfolio2026.com/backend/public/api");
  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  const [baseUrlForFile, setBaseUrlForFile] = useState("https://esthetica.btsportfolio2026.com/backend/public/storage");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("http://127.0.0.1:8000/storage");
  const [selectedTreatmentFromLandingPage, setSelectedTreatmentFromLandingPage] = useState();
  const [selectedPostFromLandingPage, setSelectedPostFromLandingPage] = useState();
  const [selectedDealFromLandingPage, setSelectedDealFromLandingPage] = useState();

  return (
    <AppContext.Provider value={{
      baseUrl, setBaseUrl, selectedTreatmentFromLandingPage,
      setSelectedTreatmentFromLandingPage, baseUrlForFile, setBaseUrlForFile,
      selectedPostFromLandingPage, setSelectedPostFromLandingPage,
      selectedDealFromLandingPage, setSelectedDealFromLandingPage,
      selectedVoice, setSelectedVoice,
      selectedAvatar, setSelectedAvatar
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useBaseUrl = () => useContext(AppContext);
export default AppContext;